import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ErrorService} from 'src/app/services/error.service';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-error-banner',
  templateUrl: './error-banner.component.html',
  styleUrls: ['./error-banner.component.scss'],
  imports: [NgIf]
})

export class ErrorBannerComponent implements OnInit {
  private _errorService = inject(ErrorService);
  private _destroyRef = inject(DestroyRef);

  public errorMessage: string | null = null;

  public ngOnInit() {
    this._errorService.error$
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(message => {
        this.errorMessage = message;
      });
  }
}
